import Vue from "vue";
export async function fetchParentSurveys({ commit }) {
  commit("cleanErrors");
  await Vue.axios({
      method: "GET",
      url: `/survey/`
    })
    .then(response => {
      commit("setParentSurveys", response.data)
    })
    .catch(error => {
      commit("error", error);
    });
}